import { useInView } from "react-intersection-observer"

export const useIntersectionObserver = ({
  threshold,
  initialInView,
  onChange
}: UseIntersectionObserver.Props): UseIntersectionObserver.ReturnType => {
  const { ref, inView: isInView } = useInView({
    threshold,
    initialInView,
    onChange
  })

  return {
    ref,
    isInView
  }
}

namespace UseIntersectionObserver {
  export type Props = {
    threshold: number | Array<number>
    initialInView?: boolean
    onChange?: (inView: boolean) => void
  }

  export type ReturnType = {
    ref: (node: Element | null) => void
    isInView: boolean
  }
}
